import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import HelpRounded from '@mui/icons-material/HelpRounded';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';

const ButtonHelpModal = () => {
  const { t } = useTranslation('planAction');
  const [showModal, setShowModal] = useState(false);

  return (
    <Box>
      <IconButton onClick={() => setShowModal(true)} size="small">
        <HelpRounded color="primary" />
      </IconButton>
      <Dialog open={showModal} onClose={() => setShowModal(false)}>
        <DialogTitle
          alignItems="center"
          display="flex"
          justifyContent="flex-end"
        >
          <IconButton onClick={() => setShowModal(false)}>
            <CloseIcon color="primary" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 2 }}>{t('Statistics.Status.Waterfall.Help.Text')}</Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ButtonHelpModal;
